import CareerCounselling from "../components/CareerCounselling"
import Footer from "../components/footer"
import Header from "../components/header"

const CareerCounsellingPage =()=>{
    return(
        <>
        {<Header/>}
        {<CareerCounselling/>}
        
        </>
    )
}
export default CareerCounsellingPage; 